import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Renewal History</h3>
                <p className="text-sm text-gray-600">
                    Track the history of documentation renewals for your fleet.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Adding Renewal Records</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li>Click <strong>Add Renewal</strong> to record a completed renewal.</li>
                    <li>Specify the <strong>Type</strong> (e.g., Insurance, Permit, Registration), <strong>Vendor</strong>, and <strong>Validity Period</strong>.</li>
                    <li>The system tracks the <strong>Start Time</strong> and <strong>End Time</strong> to monitor document validity.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Audit and Search</h4>
                <p className="text-sm text-gray-600">
                    Use the <strong>Search Bar</strong> to find renewal logs for specific vehicles or document types. This is essential for maintaining compliance.
                </p>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Export Data</h4>
                <p className="text-sm text-gray-600">
                    Export your renewal history to <strong>PDF</strong> or <strong>CSV</strong> for compliance reporting or audit preparation.
                </p>
            </section>
        </div>
    );
};

export default Help;
